<template>
    <div class="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu">
 
         <div class="layout-container">
             <NavBar />
             <!-- Layout container -->
             <div class="layout-page">
                 <!-- Content wrapper -->
                 <div class="content-wrapper">
                     
                     <!-- Menu -->
                     <MenuItem />
 
                     <!-- Content -->
                     <div class="container-xxl flex-grow-1 container-p-y">
 
                         <h4 class="fw-bold py-3 mb-4"><span class="text-muted fw-light">NSIA ASSURANCE /</span> Gestion des utilisateurs</h4>
 
                         <!-- <Button 
                             type="button" class="mb-5" icon="pi pi-filter-slash" 
                             label="Ajouter une bande" outlined @click="clearFilter()" 
                         /> -->
                         <button style="text-transform: none;"
                             class="btn btn-label-primary waves-effect mb-3" 
                             @click="display=true">
                             <i class="pi pi-plus"></i>&nbsp;
                             Ajouter un utilisateur
                         </button>
                         <DataTable 
                             v-model:filters="filters" :value="utilisateurs" sortMode="multiple" paginator dataKey="id" :rows="10" 
                             :rowsPerPageOptions="[5,10, 30, 50, 100]"  tableStyle="min-width: 50rem" filterDisplay="menu" 
                             :globalFilterFields="['nom', 'prenoms', 'email']"
                         >
                             <!-- paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                             currentPageReportTemplate="{first} to {last} of {totalRecords}" -->
                             
                             <template #header>
                                 <div class="flex justify-content-between">
 
                                     <!-- <Button 
                                         type="button" icon="pi pi-filter-slash" 
                                         label="Annuler la recherche" outlined 
                                         class="btn btn-label-primary waves-effect"
                                         @click="clearFilter()" 
                                     /> -->
                                     <button style="text-transform: none;"
                                         class="btn btn-label-primary waves-effect" 
                                         @click="clearFilter()" 
                                     >
                                         <i class="pi pi-filter-slash"></i>&nbsp;
                                         Annuler la recherche
                                     </button>
                                     <span class="p-input-icon-left">
                                         <i class="pi pi-search" />
                                         <InputText v-model="filters['global'].value" placeholder="Rechercher" />
                                     </span>
 
                                 </div>
                             </template>
 
                             <Column field="nom" header="Nom" sortable style="width: 25%"></Column>
                             <Column field="prenoms" header="Prenoms" sortable style="width: 25%"></Column>
                             <Column field="email" header="Adresse email" sortable style="width: 25%"></Column>
                             <Column field="profil" header="Profil"  style="width: 25%"></Column>
                             <Column field="nbr_prospect" header="Nombre prospect enregistré"  style="width: 25%">
                                <template #body="slotProps">
                                     <span>{{ slotProps.data.nbr_prospect }} /10</span>
                                     <div class="progress" style="height: 10px">
                                        <div class="progress-bar" role="progressbar" :style="{'width': `${getPercent(slotProps.data.nbr_prospect)}%`}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                             {{getPercent(slotProps.data.nbr_prospect)}}%
                                        </div>
                                    </div>
                                 </template>
                            </Column>
                             <Column field="created_at" header="Creé le"  style="width: 25%">
                                 <template #body="slotProps">
                                     {{ new Date(slotProps.data.created_at).toLocaleDateString('fr-FR', options) }}
                                 </template>
                             </Column>
                             <Column field="updated_at" header="Modifié le" sortable="" style="width: 25%">
                                 <template #body="slotProps">
                                     {{ new Date(slotProps.data.updated_at).toLocaleDateString('fr-FR', options) }}
                                 </template>
                             </Column>
                             <Column headerStyle="width:4rem">
                                 <template #body="slotProps">
                                     <button type="button" 
                                         class="btn btn-label-primary waves-effect" 
                                         data-bs-toggle="dropdown" aria-expanded="false"
                                     >
                                         <i  class="pi pi-bars"/>
                                     </button>
                                     <ul class="dropdown-menu">
                                         <li>
                                             <a 
                                                 @click="showDonnees(slotProps.data)"
                                                 class="dropdown-item waves-effect" 
                                                 href="javascript:void(0);"
                                             >
                                                 Modifier
                                             </a>
                                         </li>
                                         <li>
                                             <a 
                                                 @click="deleteUser(slotProps.data)"
                                                 class="dropdown-item waves-effect" 
                                                 href="javascript:void(0);"
                                             >
                                                 Supprimer 
                                             </a>
                                         </li>
                                     </ul>
                                     <!-- 
                                         @click="showDonnees(slotProps.data)" <SplitButton label="preferences" :model="items"  class="mb-2"></SplitButton> -->
                                 </template>
                             </Column>
 
                             <template #paginatorstart>
                                 <Button type="button" class="btn btn-label-primary waves-effect" icon="pi pi-refresh" text @click="getUtilisateurs" />
                             </template>
 
                             <template #paginatorend>
                                 <Button type="button" class="btn btn-label-primary waves-effect" icon="pi pi-download" text />
                             </template>
 
                         </DataTable>
                         
 
                     </div>
                 </div>
             </div>
         </div>
         <!-- Modal ajout ferme -->
         <Dialog v-model:visible="display" :style="{ width: '50vw' }"  modal header="Ajouter un utilisateur"  position="center">
                     <div class="container mt-4">
                         <form @submit="addUser($event)">
                         <div class="row">
                             <div class="col-6">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="text" class="form-control"  placeholder="Libelle" v-model="data.nom">
                                     <label for="basic-default-fullname">Nom</label>
                                 </div>
                             </div>
                             <div class="col-6">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="text" class="form-control"  placeholder="Libelle" v-model="data.prenoms">
                                     <label for="basic-default-fullname">Prenoms</label>
                                 </div>
                             </div>
                             <div class="col-6">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="email" class="form-control"  placeholder="Libelle" v-model="data.email">
                                     <label for="basic-default-fullname">Email</label>
                                 </div>
                             </div>
                             <div class="col-6">
                                <div class="form-password-toggle">
                                    <div class="input-group input-group-merge">
                                        <div class="form-floating form-floating-outline">
                                            <input :type=" showPassword ? 'password' : 'text' " id="password" class="form-control"
                                                name="password" v-model="data.password"
                                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                                aria-describedby="password" />
                                            <label for="password">Mot de passe</label>
                                        </div>
                                        <span class="input-group-text cursor-pointer" @click="seePassword">
                                            <i :class=" showPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline' "></i>
                                        </span>
                                    </div>
                                </div>
                             </div>
                             <div class="col-12">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="data.profil">
                                    <option value="administrateur">Administrateur</option>
                                    <option value="gestionnaire">Gestionnaire</option>
                                    <option value="lecteur">Lecteur</option>
                                   </select>
                                   <label for="selectpickerBasic">Nature prospection</label>
                               </div>
                          </div>
                         </div>
                         <button type="submit" class="mt-3 btn w-100 btn-primary waves-effect waves-light" :disabled="canAdd">Enregistrer</button>
                     </form>
                     </div>
        </Dialog>
             <!-- Modal modification ferme -->
             <Dialog v-model:visible="display_edit" :style="{ width: '50vw' }" modal header="Modification"  position="center">
                <div class="container mt-4">
                         <form @submit="updateUser($event)">
                         <div class="row">
                             <div class="col-6">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="text" class="form-control"  placeholder="Libelle" v-model="data.nom" disabled>
                                     <label for="basic-default-fullname">Nom</label>
                                 </div>
                             </div>
                             <div class="col-6">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="text" class="form-control"  placeholder="Libelle" v-model="data.prenoms" disabled>
                                     <label for="basic-default-fullname">Prenoms</label>
                                 </div>
                             </div>
                             <div class="col-6">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="email" class="form-control"  placeholder="Libelle" v-model="data.email" disabled>
                                     <label for="basic-default-fullname">Email</label>
                                 </div>
                             </div>
                             
                             <div class="col-6">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="data.profil" disabled>
                                    <option value="administrateur">Administrateur</option>
                                    <option value="gestionnaire">Gestionnaire</option>
                                    <option value="lecteur">Lecteur</option>
                                   </select>
                                   <label for="selectpickerBasic">Nature prospection</label>
                               </div>
                          </div>
                         </div>
                         <button v-if="false" type="submit" class="mt-3 btn w-100 btn-primary waves-effect waves-light" :disabled="canAdd">Enregistrer</button>
                     </form>
                     </div>
             </Dialog>
    </div>
 </template>
 
 
 <script>
     // Import the CSS or use your own!
     import MenuItem from "@/components/MenuItem";
     import NavBar from "@/components/NavBar";
     
     // import { menu } from "@/assets/vendor/js/menu.js";
     import "vue-toastification/dist/index.css";
     import { useToast } from "vue-toastification";
     const toast = useToast();
     // import { VDataTable } from 'vuetify/labs/VDataTable';
     import { apiUrl } from "@/constants/config";
     import DataTable from 'primevue/datatable';
     import Column from 'primevue/column';
     import ColumnGroup from 'primevue/columngroup';   // optional
     import Row from 'primevue/row';                   // optional
     import Dialog from 'primevue/dialog';
     import Calendar from 'primevue/calendar';
     import { FilterMatchMode, FilterOperator } from 'primevue/api';
 
     export default{
         name : 'UtilisateurView',
         components : {
             NavBar, MenuItem,
             // VDataTable, 
             DataTable, Column, ColumnGroup, Row,
             //modal
             Dialog
         },
         data() {
             return {
                 data : {nom : '', prenoms:'', email : '', password : '',profil : ''},
                 utilisateurs : [],
                 options : { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
                 search: '',
                 consommations: [], 
                 filters: null,
                 display : false,
                 display_edit : false,
                 showPassword : true,
             }
         },
 
         created(){
             this.initFilters()
         },
         mounted(){
             this.getUtilisateurs()
         },
         computed : {
            canAdd(){
                return this.data.email == '' || this.data.password == '' || this.data.nom == '' || 
                this.data.prenoms == '' || this.data.profil == ''
            }
         },
         methods : {
            async getUtilisateurs()
            {
                const response = await this.$axios.get('admin/all')
                this.utilisateurs = [...response.data.data]
            },
             async addUser(e){
                 e.preventDefault();
                    let datas = new FormData()
                    for (const object in this.data) {
                      datas.append(object, this.data[object])
                    }   
                    let response = await this.$axios.post('admin/register', datas);
                     console.log(response);
                     if(response.data.code ==400){
                         toast.error(response.data.message)
                         return
                     }
                     toast.success(response.data.message)
                     for (const object in this.data) {
                      this.data[object] = ''
                    } 
                     this.display = false
                     this.getUtilisateurs()
             },
             async updateUser(e){
                    e.preventDefault();
                    let datas = new FormData()
                    for (const object in this.data) {
                      datas.append(object, this.data[object])
                    } 

                    let response = await this.$axios.post(`admin/account/update_profile`, datas);
                       
                     if(response.data.code ==400){
                         toast.error(response.data.message)
                         return
                     }
                     toast.success(response.data.message)
                     for (const object in this.data) {
                      this.data[object] = ''
                    } 
                     this.display_edit = false
                     this.getUtilisateurs()
 
             },
             seePassword(){
                this.showPassword = !this.showPassword
             },
             getPercent(nbr){
                return (nbr /10) * 100
             },
             async deleteUser(datas){
                const data = new FormData()
                data.append('id', datas.id)
                this.$swal({
                    title: 'NSIA VIE',
                    text: "Voulez supprimer l'utilisateur",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Supprimer',
                    cancelButtonText: 'Annuler'
                    }).then(async (result)=>{
                        if(result.isConfirmed){
                            const response = await this.$axios.post(`admin/delete`, data)
                            if(response.code){
                                toast.error(response.data.message)
                                return
                            } else{
                                toast.success(response.data.message)
                                this.getUtilisateurs()
                            }
                        }
                    })
                        
            },
             clearFilter() {
                 this.initFilters();
             },
 
             initFilters() {
                 this.filters = {
                     global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                     reference: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                 };
             },
             showDonnees(donnees){
                 this.data = {...donnees}
                 
                 this.display_edit = true
             },
             resetDatas(){
                 this.datas.quantite = ''
                 this.datas.aliment_id = ''
                 this.datas.bande_id = ''
             }
         },
 
     }
 
 </script>
 
 <style>
 
 </style>